import axios from 'axios';
import { GET_IP_ADDRESS } from '../../apiConst';
import { toast } from 'react-toastify';
const baseUrl = process.env.REACT_APP_BASE_URL;

axios.interceptors.request.use(
  function (config) {
    if (config.url !== GET_IP_ADDRESS)
      config.headers.token = localStorage.getItem('userAuthToken');
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

export const getRequest = (url, params, config = {}) =>
  axios
    .get(baseUrl + url, { ...config, params })
    .then((response) => {
      if (response?.data?.status === 400) {
        handleError(response);
      } else {
        console.log(response);
        return response.data;
      }
    })
    .catch((error) => handleError(error));

export const postRequest = async (url, payload, config = {}, params) =>
  await axios
    .post(baseUrl + url, payload, { ...config, params })
    .then((response) => {
      const { status } = response.data;
      if (status === 400) {
        handleError(response);
      } else {
        return response;
      }
    })
    .catch((error) => {
      return handleError(error);
    });

export const putRequest = (url, payload, config = {}, params) =>
  axios
    .put(baseUrl + url, payload, { ...config, params })
    .then((response) => {
      if (response.status === 200) {
        return response;
      } else {
        handleError(response);
      }
    })
    .catch((error) => {
      return handleError(error);
    });

export const deleteRequest = (url, payload, config = {}, params) =>
  axios
    .delete(baseUrl + url, { data: payload }, { ...config, params })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return handleError(error);
    });

export const handleError = (error) => {
  console.log('error in handleError', error);
  if (error?.response && error.response.status === 401) {
    localStorage.removeItem('userAuthToken');
    window.location.href = '/seva-login'; // if unauthorized logout from the session
    error?.response?.data?.message &&
      toast.error(error?.response?.data?.message);
  } else if (error?.response && error.response.status === 400) {
    error?.response?.data?.message &&
      toast.error(error?.response?.data?.message);
    console.log('Error', error?.response?.data?.message);
  } else if (error?.response && error.response.status === 500) {
    error?.response?.data?.message &&
      toast.error(error?.response?.data?.message);
    console.log('Error', error?.response?.data?.message);
  }
  console.log('interceptor file handleError function ~', error);
};
